import client, { mock, isRealApiEnabled } from "./client";

const autosaves = {};

function key(productId, versionId) {
  return versionId ? `${productId}_${versionId}` : productId;
}

function query(versionId) {
  return versionId ? `?versionId=${encodeURIComponent(versionId)}` : "";
}

export function get(productId, versionId) {
  if (isRealApiEnabled())
    return client
      .get(`/v1/autosaves/${encodeURIComponent(productId)}${query(versionId)}`)
      .catch((err) => {
        if (err && err.status === 404) return null;
        throw err;
      });
  return mock(autosaves[key(productId, versionId)] || null);
}

export function save(productId, versionId, content) {
  if (isRealApiEnabled())
    return client.put(
      `/v1/autosaves/${encodeURIComponent(productId)}${query(versionId)}`,
      content
    );
  // Mirror the real backend (storeProductAutoSavesMongo): persist a JSON-cloned
  // snapshot and stamp `updatedAt`. Cloning drops `undefined` keys exactly as a
  // network round-trip would, so callers that null out large fields (e.g.
  // productImages/variations) by setting them to `undefined` don't end up
  // overwriting the live form with `undefined` on restore. `updatedAt` also
  // lets the editor compare the autosave against the server product's save time.
  const clonedContent = JSON.parse(JSON.stringify(content ?? {}));
  autosaves[key(productId, versionId)] = {
    productId,
    versionId,
    content: clonedContent,
    updatedAt: new Date().toISOString(),
  };
  return mock({ productId, saved: true });
}

export function remove(productId, versionId) {
  if (isRealApiEnabled())
    return client.del(
      `/v1/autosaves/${encodeURIComponent(productId)}${query(versionId)}`
    );
  delete autosaves[key(productId, versionId)];
  return mock({ productId, deleted: true });
}
